import { render, staticRenderFns } from "./CheckinPromotionList.vue?vue&type=template&id=0516da36&scoped=true&"
import script from "./CheckinPromotionList.vue?vue&type=script&lang=js&"
export * from "./CheckinPromotionList.vue?vue&type=script&lang=js&"
import style0 from "./CheckinPromotionList.vue?vue&type=style&index=0&id=0516da36&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0516da36",
  null
  
)

export default component.exports